import React from 'react';
import support from '../images/screen_12.png';
import mamitoIMG from "../images/mamito.jpeg";
import girlieIMG from "../images/girlie.jpeg";
import broIMG from "../images/bro.jpeg";
import useInView from "../lib/useInView";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faEnvelopesBulk,
    faLandmarkFlag,
    faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet";
import MarketMarquee from '../users/MarketMarquee';



const Contact = () => {

    const [box1Ref, box1InView] = useInView({ threshold: 0.7 });
    const [box6Ref, box6InView] = useInView({ threshold: 0.7 });
    const [box7Ref, box7InView] = useInView({ threshold: 0.7 });
    const [box9Ref, box9InView] = useInView({ threshold: 0.7 });
    const [box8Ref, box8InView] = useInView({ threshold: 0.7 });


    return (
        <>
            <Helmet>
                <title>Contact Us</title>
            </Helmet>

            <div id="hero-section">
                <div className="hero-section">
                    {/* Left Box: Text and Sub-Boxes */}
                    <div className="hero-text-container">
                        <h1 className="hero-title">
                            Contact Support for Prompt Assistance
                        </h1>
                        <p className="hero-description">
                            As Mega National Assets evolve across the globe, you need a bespoke approach from a service provider with a genuine understanding of how markets are changing.                              </p>
                    </div>

                    {/* Right Box: Image */}
                    <div className="hero-image-container">
                        <img
                            src={support}
                            alt="Hero"
                            ref={box1Ref}
                            className={`hero-image animate__animated ${box1InView ? "custom-animation" : ""}`}
                        />
                    </div>
                </div>

                {/* Display Sliding Carousel */}
                <MarketMarquee />
            </div>


            <div>
                <div className="sub-containers">
                    <div className="sub-box heading-cover-bg">
                        <div
                            ref={box6Ref}
                            className={`icon-title-text-container animate__animated ${box6InView ? "animate__zoomInRight" : ""}`}
                        >
                            <FontAwesomeIcon icon={faEnvelopesBulk} className="box-icon" />
                            <div
                                className="title-text">
                                <h3 className="box-title black-title">
                                    Email
                                </h3>
                                <div className="box-text search-container black-title">
                                    support.team@online.megastockassets.com (Quick Response)
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="sub-box heading-cover-bg">
                        <div
                            ref={box6Ref}
                            className={`icon-title-text-container animate__animated ${box6InView ? "animate__zoomInRight" : ""}`}
                        >
                            <FontAwesomeIcon icon={faLandmarkFlag} className="box-icon" />
                            <div
                                className="title-text">
                                <h3 className="box-title black-title">
                                    Server Address
                                </h3>
                                <div className="box-text search-container black-title">
                                   301 East Water Street, Charlottesville, VA 22904 Virginia
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="sub-box heading-cover-bg">
                        <div
                            ref={box6Ref}
                            className={`icon-title-text-container animate__animated ${box6InView ? "animate__zoomInRight" : ""}`}
                        >
                            <FontAwesomeIcon icon={faPhone} className="box-icon" />
                            <div
                                className="title-text">
                                <h3 className="box-title black-title">
                                    Phone Number
                                </h3>
                                <div className="box-text search-container black-title">
                                    VIP ACCESS ONLY - May be congested or unavailable.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {/* next content here */}
            <div className="main-box-cover">
                <h2 className="text-heading centered">
                    More Choices - <span> More Possibilities.</span>
                </h2>
                <div className="box-text centered">
                    We offer our clients comprehensive investment solutions that are tailored to each particular client’s needs at a specific period of time.
                    For years, we have been providing secure and easy U.S. investments to over 400,000 who live, travel, shop and work in the U.S. We make cross-border investments easy and secure.
                </div>
            </div>


            <div className="last-section">
                <div className="box">
                    <div
                        ref={box9Ref}
                        className={`icon-title-text-container animate__animated ${box9InView ? "animate__zoomInRight" : ""}`}
                    >
                        <img
                            src={girlieIMG}
                            className="boxed-icon"
                            alt="GLOBAL HUMANITARIAN OUTREACH"
                        />
                        <div className="title-text">
                            <h2 className="box-title">
                                GLOBAL HUMANITARIAN OUTREACH
                            </h2>
                            <div className="box-text">
                                We actively collaborate with communities and organizations around the world to support crisis relief, provide food, education, and healthcare, and deliver hope where it's needed most.
                            </div>
                        </div>
                    </div>
                    <h2 className="text-heading centered">
                        Navigate complexity with a trusted capital markets services partner — and a heart for humanity.
                    </h2>
                    <a href="/charity" className="cta-button">
                        Learn More About Our Charity Work
                    </a>
                </div>

                <div className="box">
                    <div
                        ref={box7Ref}
                        className={`icon-title-text-container animate__animated ${box7InView ? "animate__zoomInRight" : ""}`}
                    >
                        <img
                            src={mamitoIMG}
                            className="boxed-icon"
                            alt="ECONOMIC EMPOWERMENT INITIATIVES"
                        />
                        <div className="title-text">
                            <h2 className="box-title">
                                ECONOMIC EMPOWERMENT INITIATIVES
                            </h2>
                            <div className="box-text">
                                We invest in people by supporting small businesses, vocational training, and financial education—empowering individuals and families to build sustainable futures.
                            </div>
                        </div>
                    </div>

                    <div
                        ref={box8Ref}
                        className={`icon-title-text-container animate__animated ${box8InView ? "animate__zoomInRight" : ""}`}
                    >
                        <img
                            src={broIMG}
                            className="boxed-icon"
                            alt="EDUCATION & RESETTLEMENT SUPPORT"
                        />
                        <div className="title-text">
                            <h2 className="box-title">
                                EDUCATION & RESETTLEMENT SUPPORT
                            </h2>
                            <div className="box-text">
                                From scholarships to relocation assistance, we help students and displaced families access quality education and stable environments to restart and thrive.
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}

export default Contact;
